module.exports = {"440605011":"桂城街道","440605121":"九江镇","440605122":"西樵镇","440605123":"丹灶镇","440605124":"狮山镇","440605125":"大沥镇","440605126":"里水镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440605.json
// module id = 2112
// module chunks = 0